import React from 'react';
import { makeStyles } from 'tss-react/mui';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const useStyles = makeStyles()((theme) => ({
  title: {
    ...theme.typography.h5,
    color: theme.palette.primary.main,
    paddingTop: 16,
  },
  subtitle: {
    ...theme.typography.body1,
    marginLeft: theme.spacing(3),
  },
  list: {
    ...theme.typography.body2,
    marginLeft: theme.spacing(5),
  },
}));

const TermsOfUseMain = () => {
  const { classes } = useStyles();
  return (
    <div>
      <div id="scopeAndApplication">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          1. Scope and Application.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          1.1 General. BY ACCESSING THE SITE OR USING THE SERVICES AND CONDUCTING TRANSACTIONS WITH US IN CONNECTION
          WITH THE SITE AND SERVICES, YOU HEREBY: (1) ACCEPT THESE TERMS AND CONDITIONS AND AGREE THAT YOU ARE LEGALLY
          BOUND BY ITS TERMS; (2) AGREE THAT YOU WILL COMPLY WITH AND BE BOUND BY THESE TERMS AND CONDITIONS EACH TIME
          YOU ACCESS THE SITE AND USE THE SERVICES, (3) AGREE THAT EACH USE OF THE SITE AND SERVICES BY YOU INDICATES
          AND CONFIRMS YOUR ASSENT TO AND AGREEMENT TO BE BOUND BY THESE TERMS AND CONDITIONS; AND (4) REPRESENT,
          WARRANT AND COVENANT THAT: (A) YOU ARE OF LEGAL AGE TO ENTER INTO A BINDING AGREEMENT; AND (B) IF YOU ARE A
          CORPORATION, GOVERNMENTAL ORGANIZATION OR OTHER LEGAL ENTITY, THAT YOU HAVE THE RIGHT, POWER, AND
          AUTHORIZATION TO ENTER INTO THIS AGREEMENT ON BEHALF OF YOUR CORPORATION, GOVERNMENTAL ORGANIZATION OR OTHER
          LEGAL ENTITY. IF YOU DO NOT AGREE TO THESE TERMS AND CONDITIONS, YOU MUST NOT ACCESS THE SITE OR USE THE
          SERVICES.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          1.2 Certain Definitions.{' '}
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) The terms “<strong>JLIVE</strong>” “<strong>we</strong>”, “<strong>us</strong>”, and “<strong>our</strong>
          ” used in these Terms and Conditions refer, collectively, to JLIVE, Federation CJA and Jewish Federation of
          Metropolitan Detroit and their respective affiliates, successors and assigns and their respective officers,
          directors, employees, mandataries and agents.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) The term “<strong>Organizer</strong>” means an organization or person that uses the Services to create
          events (“<strong>Events</strong>”) that individuals using the Services may learn about or attend. Organizers,
          individuals and others using our Services are all referred to in these Terms and Conditions collectively as “
          <strong>Users</strong>,” “<strong>you</strong>” or “<strong>your</strong>.” If you will be using the Services
          on behalf of an entity (for example, on behalf of your employer), “you” and “your” will refer to that entity
          as well as yourself.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (c) The term “<strong>Conten</strong>t” means all material, including without limitation information,
          software, data, text, editorial content, design elements, formatting, graphics, images, photographs, video,
          audio, music, sounds and other content contained in, made available through or delivered by means of the
          Services or otherwise made available in connection with the Services.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (d) The term “<strong>Your Content</strong>” means any material (including the foregoing categories) that you
          contribute, provide, post or make available using the Services.
        </h3>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          1.3 Scope.{' '}
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) Depending on your place of residence, your contract incorporating these Terms and Conditions will be with
          either JLIVE LLC (Users resident in the United States of America) or Federation CJA (Users resident in
          Canada). If you change your place of residence, the JLIVE entity you contract with will be determined by your
          new place of residence as specified above from the date on which your place of residence changes.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) We may sometimes provide you with services that are not described in these Terms and Conditions, or
          customized services. Unless we have entered into a separate, signed agreement that expressly supersedes these
          Terms and Conditions, these Terms and Conditions will apply to those services as well.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (c) We may sometimes use the JLIVE Services as an Organizer to create or organize Events on our own behalf.
          Subject to the foregoing, you acknowledge that JLIVE does not create, organize or own the Events listed on the
          Services. JLIVE’s Services provide a platform that allows Organizers to publish information about an Event and
          manage Event registration in accordance with these Terms and Conditions, including Section 3 and Section 6. We
          are the creators and owners only of those Events that we create and organize on our own behalf, as Organizers
          using JLIVE.
        </h3>
      </div>

      <div id="restrictionsOnUse">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          2. Restrictions on Use.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          2.1 General. As a condition of your use of the Services, you agree:
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) not to use the Services for any purpose that is unlawful under applicable law, or prohibited by these
          Terms and Conditions;
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) not to defame or disparage anybody or make comments of an obscene, derogatory or offensive manner or
          otherwise use the Services or its Content in a way that brings us or any third party into disrepute or causes
          us to be liable to any third party;
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (c) not to reverse engineer, decompile, copy, modify, distribute, transmit, license, sublicense, display,
          revise, perform, transfer, sell or otherwise make available to any third party or otherwise publish,
          deep-link, create derivative works from or exploit in any way the Services or its Content except as permitted
          by us under these Terms and Conditions or as expressly provided under applicable law;
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (d) not to use the Services to distribute viruses or malware or other similar harmful software code; or
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (e) not to represent or suggest that we endorse any other business, product or service unless we have
          separately agreed to do so in writing.
        </h3>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          2.2 Further Acknowledgements. You further acknowledge and agree that: (a) you are solely responsible for all
          costs and expenses you may incur in relation to your use of the Services; (b) you have no right to use, and
          agree not to use, any Content for your own commercial purposes; (c) you have no right to, and agree not to
          scrape, crawl, or employ any automated means to extract data from the Services; and (d) we reserve the right
          to prevent or suspend your access to the Services if you do not comply with any part of these Terms and
          Conditions or any applicable law.
        </h2>
      </div>

      <div id="representations">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          3. Representations and Obligations Specific to Organizers.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.1 Organizer Specific Provisions. If you are an Organizer, all of the provisions of this section apply to you
          and your affiliates in addition to the rest of these Terms and Conditions. You represent and warrant that (i)
          all information pertaining to an Event created by the Organizer and displayed in the Services and (ii) the
          Event itself meet all applicable local, state, provincial, national and other laws, rules and regulations, and
          that all goods and services offered in relation to an Event and described in the Services are delivered as
          described and in an accurate, satisfactory manner.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.2 Personal Information. You are solely responsible and accountable for the collection, use and disclosure of
          all personal information that you have obtained by using our Services. For greater certainty, JLIVE is
          responsible for personal information of Users solely with respect to JLIVE’s collection, use and disclosure of
          such personal information as needed to provide the Services, as more fully described in our Privacy Policy.
          You represent and warrant that you will at all times (a) comply with all applicable local, state, provincial,
          national and other laws, rules and regulations with respect to personal information you collect, use or
          disclose, and (b) protect the confidentiality, security, privacy and handling of such personal information by
          maintaining an information security program consisting of administrative, technical, and physical safeguards
          appropriate to the sensitivity of the information collected, used or disclosed.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.3 Personnel. You are fully responsible and liable for the acts and omissions of your employees, agents,
          consultants, subcontractors or representatives (“<strong>Personnel</strong>”), if any, involved in the
          services you provide in connection with Events, and you will ensure that all Personnel comply with your
          obligations under these Terms and Conditions.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.4 Tickets. You will ensure that the applicable procedures to ensure the validity of tickets sold for your
          Event will always be followed. JLIVE will not be held liable under any circumstances for any costs or damages
          arising from: (a) non-compliance by Organizers with applicable procedures that must be implemented by
          Organizers to ensure the validity of tickets, (b) situations involving fraud, or (c) ticket purchases made
          outside of the Services or by non-official means, such as through third party resellers.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.5 Organizers or Events in Quebec. You will comply, and agree that you are solely responsible for complying,
          with all requirements of the <em>Charter of the French Language</em> CQLR c C-11 that may apply to you in
          relation to (a) your Events and the promotion thereof, and (b) your communications concerning such Events.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.6 Additional Organizer Representation and Warranties. Without limiting the generality of any representations
          or warranties provided elsewhere in these Terms of Service, you represent and warrant to us that:
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) You will obtain, prior to the start of ticket sales, all applicable licenses, permits, and authorizations
          (individually and collectively, <strong>Permits</strong>) with respect to events hosted by you or your
          affiliates on the Services. Permits includes but is not limited to property operation permits and fire marshal
          permits;
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) You will comply, and will ensure that the venues for each event hosted by you or your affiliates on the
          Services will comply, with all applicable laws, regulations, rules and ordinances; and
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (c) You will only offer tickets to an Event after you have obtained any specific Permits for such Event,
          including, but not limited to, any state, county, municipal or other local authority’s authorization of the
          Event, traffic engineering authorizations, fire department inspection reports, authorization to receive minors
          (if applicable), sanitary authorization (if applicable), and any other potential applicable authorization; and
          (d) you will maintain in force throughout the term of access to the Service the applicable Permits for the
          Organizer to promote, produce, sponsor host and sell tickets for all events hosted by you or your affiliates
          on the Services.
        </h3>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.7 Permits. You agree to provide evidence of Permits and related information promptly upon the reasonable
          request of JLIVE from time to time.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          3.8{' '}
          <strong>
            RELEASE. TO THE FULLEST EXTENT PERMITTED BY LAW, YOU HEREBY AGREE TO RELEASE JLIVE, JEWISH FEDERATION OF
            METROPOLITAN DETROIT AND [FEDERATION CJA] AND EACH OF THEIR RESPECTIVE OFFICERS, AFFILIATES,
            REPRESENTATIVES, SHAREHOLDERS, CONTRACTORS, DIRECTORS, AGENTS, PARTNERS AND EMPLOYEES FROM ALL DAMAGES
            (WHETHER DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL OR OTHERWISE), LOSSES, LIABILITIES, COSTS AND EXPENSES
            OF EVERY KIND AND NATURE, INCLUDING, WITHOUT LIMITATION, ATTORNEYS’ FEES, KNOWN AND UNKNOWN, ARISING OUT OF
            OR IN ANY WAY CONNECTED WITH YOUR OR YOUR AFFILIATES’ PERMITS, ANY FAILURE TO OBTAIN OR MAINTAIN ANY
            PERMITS, OR ANY ERROR IN OBTAINING OR MAINTAINING ANY PERMITS.
          </strong>
        </h2>
      </div>

      <div id="yourJliveAccount">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          4. Your JLIVE Account.{' '}
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          We may require you to create an account to access certain features or functions of the Services. Your account
          constitutes part of the Services and your use of your account is governed by these Terms and Conditions. You
          agree to follow certain rules when you create an account with JLIVE or use the Services, including the
          following:
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          4.1 You must be the legal age of majority where you reside to use the Services. If you are between 13 and 18
          (inclusive), you may only use the Services under the supervision of a parent or legal guardian who manages
          your use and/or account. The Services are not intended for use by Users or persons under the age of 13. If you
          are under 13, you are not permitted to use the Services.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          4.2 You agree to provide true, accurate, current and complete information about yourself, or if you are using
          the Services on behalf of another person or organization, such other person or organization. You also agree to
          update such information if it changes.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          4.3 In any dispute between two or more parties as to account ownership, JLIVE will be the sole arbiter of that
          dispute and our decision, which may include termination or suspension of the disputed account and any other
          accounts associated with the parties to the dispute, will be final and binding on those parties.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          4.4 You agree that you are solely responsible for, and we will hold you responsible for, all activity that
          occurs under your account. You must maintain the confidentiality of your password and account details. You
          likewise agree that all rules applicable to your account will apply to all third parties to whom you grant
          access to your account.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          4.5 You agree to immediately notify JLIVE of any unauthorized use of your password or account or any other
          breach of security.
        </h2>
      </div>

      <div id="submittingInformation">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          5. Submitting Information and Your Content.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          5.1 Security and Submissions. You acknowledge and agree that the Services are not a secure means of
          communication and any information you supply to us, apart from personal information subject to our Privacy
          Policy, will not be kept confidential. For that reason, you should not submit or send to us any patentable
          ideas or patent applications, advertising or marketing suggestions, prototypes or any information, written or
          oral, which you regard as confidential or commercially sensitive or valuable (collectively referred to as “
          <strong>Unwanted Submissions</strong>”). While we value your feedback, you agree not to submit any Unwanted
          Submissions. Any submission (including any Unwanted Submission) made to us is deemed to be our property and we
          shall own all right title and interest in and to any such submission, including any intellectual property
          rights related thereto or embodied therein. Should any right or interest to such submissions inure to you,
          your hereby agree to irrevocably assign, and hereby do irrevocably assign all right title and interest in any
          such submissions to us. By transmitting or posting any submission or other material to us, you agree that,
          subject to our Privacy Policy, we are entitled to use any such information in any manner we see fit (including
          reproduction, transmission, publication, broadcast, and posting on any media and anywhere in the world) on a
          free of charge basis. We shall not be subject to any obligation of confidentiality nor be liable for any use
          and/or disclosure of such submissions.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          5.2 Your Content.{' '}
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) Where our Services enable you to communicate with us and/or other Users of the Services, Your Content must
          be accurate and truthful and you may not use the Services to transmit harmful or offensive (<em>e.g.</em>,
          violent, obscene, discriminatory, defamatory or otherwise illegal) communications or material which might
          otherwise bring us or the Services into disrepute. Although we reserve the right to monitor, edit, review or
          remove Your Content including without limitation Event listings, discussions, chats, postings, transmissions,
          and other information and communications on the Services from time to time in our sole discretion, we are
          under no obligation to do so and assume no responsibility or liability arising from (i) any Content posted on
          the Services whether by JLIVE or Users, or (ii) for any error, omission, infringement, defamatory statement,
          obscenity, or inaccuracy contained in any such Content.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) You are solely responsible for Your Content. We do not make any claim to own Your Content or any
          intellectual property rights you may have therein. You hereby grant JLIVE a non-exclusive, worldwide,
          perpetual, irrevocable, royalty-free, transferable, sublicensable right and license to access, use, reproduce,
          transmit, adapt, modify, perform, display, distribute, translate, publish and create derivative works based on
          Your Content, in whole or in part, in any media, for the purpose of operating the Services (including JLIVE’s
          promotional and marketing services, which may include without limitation, promotion of your Event in third
          party websites, apps or social media and the use of your logos and trademarks), and you hereby waive any and
          all moral rights with respect to Your Content. Notwithstanding the foregoing, you do not transfer to JLIVE any
          ownership rights in any of Your Content and nothing in these Terms and Conditions will restrict any rights
          that you may have to use and exploit Your Content outside of the Services.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (c) You represent and warrant that you have all the rights, power and authority necessary to grant the
          foregoing license, that Your Content has been lawfully provided to us and that you have all necessary consents
          to provide Your Content to us, and that all Your Content (a) does not infringe, violate, misappropriate or
          otherwise conflict with the rights of any third party; (b) complies with all applicable local, state,
          provincial, national and other laws, rules and regulations; and (c) does not violate these Terms and
          Conditions.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (d) We may preserve Your Content and account information and may also disclose Your Content and account
          information if required to do so by law or in the good faith belief that such preservation or disclosure is
          reasonably necessary to (i) comply with legal process; (ii) respond to claims that any of Your Content
          violates the rights of third parties; (iii) enforce or administer any terms and conditions applicable to our
          Services, including without limitation, these Terms and Conditions; and/or (iv) protect the rights, property
          and/or personal safety of JLIVE, its users and/or the public, including fraud prevention. You understand that
          the technical processing and transmission of the Services, including Your Content, may involve transmissions
          over various networks and/or changes to conform and adapt to technical requirements of connecting networks or
          devices.
        </h3>
      </div>

      <div id="transfersAndRefunds">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          6. Event Ticket Transfers and Refunds.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          Because all transactions are between an Organizer and its respective attendees, please contact the Organizer
          of the event to arrange for ticket transfer or any refund requests. JLIVE will not be held liable under any
          circumstances for any costs or damages arising from (i) non-compliance by Organizers with applicable
          procedures that must be implemented by Organizers to ensure the validity of tickets, (i) situations involving
          fraud, or (iii) ticket purchases made outside of the Services or by non-official means, such as through third
          party resellers.
        </h2>
      </div>

      <div id="ownership">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          7. Ownership, Use and Intellectual Property Rights.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          7.1 Services. The Services and all intellectual property rights in and to the Services, including without
          limitation any Content but excluding Your Content, are owned by us and/or our licensors. In respect of such
          Services and Content, we and our licensors reserve all our intellectual property rights, which include without
          limitation all copyright, trade-marks, domain names, design rights, database rights, patents and all other
          intellectual property rights of any kind, whether registered or unregistered anywhere in the world.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          7.2 No further Right. Nothing in these Terms and Conditions grants you any rights in the Services other than
          as necessary to enable you to access and use the Services. You agree not to adjust, try to circumvent or
          delete any intellectual property notices contained in or displayed on the Services and in particular in any
          digital rights or other security technology embedded or contained within any Content.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          7.3 Trademarks. The names, words, titles, phrases, logos, designs, graphics, icons and trademarks displayed on
          the Site or via the Services are trademarks of JLIVE or third parties. While certain third-party trademarks
          may be used by JLIVE under license, the display of such trademarks on the Services does not imply any
          relationship or license between JLIVE and the owner of the trademark, nor does it imply that JLIVE either
          recommends or endorses the products, services or business processes of the said trademark’s owner. Other
          trademarks and trade names may also be used on the Services. Except as expressly provided in these Terms and
          Conditions, the use or misuse of any trademarks or any other Content on the Services is strictly prohibited
          and nothing contained on the Services shall be construed as granting, by implication, estoppel or otherwise,
          any license or right to use any trademark without our prior written permission.
        </h2>
      </div>

      <div id="software">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          8. Software.
        </h1>
        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          Where any software is made available for downloading from the Services, this is our copyrighted work and/or
          that of our licensors. You may only use such software in accordance with the terms of use and/or end user
          license agreement, if any, which accompany the software and, subject thereto, in accordance with these Terms
          and Conditions. All such software is made available for downloading solely for your personal use in a
          non-commercial manner. Any reproduction or redistribution of software not in accordance with the terms of use,
          end user license agreement and/or these Terms and Conditions is expressly prohibited, and may result in severe
          civil and criminal penalties.Our software is warranted only to the extent expressly required by applicable law
          or according to the terms of use and/or the end user license agreement that accompany the software.{' '}
          <strong>
            WE HEREBY DISCLAIM ALL OTHER WARRANTIES, CONDITIONS AND OTHER TERMS (WHETHER EXPRESS OR IMPLIED) WITH REGARD
            TO THE SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES AND CONDITIONS OF SATISFACTORY QUALITY, FREEDOM FROM
            DEFECTS AND FITNESS FOR A PARTICULAR PURPOSE. IN NO EVENT SHALL OUR AGGREGATE LIABILITY IN RESPECT OF ANY
            SUCH SOFTWARE EXCEED THE LIMITATIONS OF LIABILITY IN THE APPLICABLE TERMS AND CONDITIONS AND/OR END USER
            LICENSE AGREEMENT.
          </strong>
        </h2>
      </div>

      <div id="hyperlinks">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          9. Hyperlinks and Third Party Sites.
        </h1>
        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          The Services may contain hyperlinks or references to third party websites other than the Services. Any such
          hyperlinks or references are provided for your convenience only. We have no control over third party websites
          and accept no responsibility for any content, material or information contained in them. The display of any
          hyperlink and reference to any third party website does not constitute an endorsement of such third party’s
          website, products or services. Your use of a third party site may be governed by the terms and conditions of
          that third party site.
        </h2>
      </div>

      <div id="disclaimerOfWarranty">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          10. Disclaimer of Warranty and Limitation of Liability.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          10.1. GENERAL DISCLAIMER. THE SITE AND SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. EXCEPT AS
          OTHERWISE EXPRESSLY REQUIRED BY APPLICABLE LAW, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WE ON
          BEHALF OF OURSELVES AND OUR RESPECTIVE LICENSORS AND SERVICE PROVIDERS MAKE NO REPRESENTATIONS, WARRANTIES,
          CONDITIONS OR OTHER TERMS AND HEREBY EXPRESSLY DISCLAIM ANY WARRANTY, WHETHER EXPRESS OR IMPLIED, IN RELATION
          TO THE PROVISION OF THE SITE OR SERVICE, INCLUDING WITHOUT LIMITATION AS TO COMPLETENESS, ACCURACY AND
          CURRENCY OF ANY CONTENT ON THE SITE, OR AS TO SATISFACTORY QUALITY, OPERABILITY, FUNCTIONALITY,
          MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT AND ANY WARRANTIES THAT MAY ARISE OUT
          OF COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE OR TRADE PRACTICE. WITHOUT LIMITATION TO THE FOREGOING, WE
          PROVIDE NO WARRANTY OR UNDERTAKING, AND MAKE NO REPRESENTATION OF ANY KIND THAT THE SITE OR SERVICES WILL MEET
          YOUR REQUIREMENTS, ACHIEVE ANY INTENDED RESULTS, BE COMPATIBLE OR WORK WITH ANY OTHER SOFTWARE, PLATFORMS,
          SYSTEMS OR SERVICES, OPERATE WITHOUT INTERRUPTION, MEET ANY PERFORMANCE OR RELIABILITY STANDARDS OR BE ERROR
          FREE OR THAT ANY ERRORS OR DEFECTS CAN OR WILL BE CORRECTED. SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF
          OR LIMITATIONS ON IMPLIED WARRANTIES OR THE LIMITATIONS ON THE APPLICABLE STATUTORY RIGHTS OF A CONSUMER, SO
          SOME OR ALL OF THE ABOVE EXCLUSIONS AND LIMITATIONS MAY NOT APPLY TO YOU. .
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          10.2 EVENTS DISCLAIMER. YOU ACKNOWLEDGE THAT JLIVE HAS NO CONTROL OVER AND DOES NOT GUARANTEE THE QUALITY,
          SAFETY, ACCURACY OR LEGALITY OF ANY EVENT OR CONTENT ASSOCIATED WITH AN EVENT, OR THE TRUTH OR ACCURACY OF ANY
          INFORMATION PROVIDED BY USERS. JLIVE HAS NO RESPONSIBILITY TO YOU FOR, AND HEREBY DISCLAIMS ALL LIABILITY
          ARISING FROM, THE ACTS OR OMISSIONS OF ANY THIRD PARTIES THAT JLIVE REQUIRES TO PROVIDE THE SERVICES, THAT AN
          ORGANIZER CHOOSES TO ASSIST WITH AN EVENT, OR THAT YOU CHOOSE TO CONTRACT WITH WHEN USING THE SERVICES. YOU
          UNDERSTAND AND AGREE THAT SOME EVENTS MAY CARRY INHERENT RISK, AND BY PARTICIPATING IN THOSE EVENTS, YOU
          CHOOSE TO ASSUME THOSE RISKS VOLUNTARILY. FOR EXAMPLE, SOME EVENTS MAY CARRY RISK OF ILLNESS, BODILY INJURY,
          DISABILITY, OR DEATH, AND YOU FREELY AND WILLFULLY ASSUME THOSE RISKS BY CHOOSING TO PARTICIPATE IN THOSE
          EVENTS.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          10.3. INFORMATION DISCLAIMER. WHILE WE USE REASONABLE EFFORTS TO INCLUDE ACCURATE AND UP-TO-DATE INFORMATION
          ON THE SERVICES, WE DO NOT REPRESENT, WARRANT OR PROMISE AND HEREBY EXPRESSLY DISCLAIM ANY WARRANTY (WHETHER
          EXPRESSLY OR BY IMPLICATION) THAT ANY CONTENT IS OR WILL REMAIN AVAILABLE, ACCURATE, COMPLETE AND UP TO DATE,
          FREE FROM BUGS, ERRORS OR OMISSIONS OR FIT OR SUITABLE FOR ANY PURPOSE. ANY RELIANCE YOU MAY PLACE ON THE
          SERVICES OR INFORMATION PROVIDED THEREIN IS AT YOUR OWN RISK AND WE MAY SUSPEND OR TERMINATE OPERATION OF THE
          SERVICES AT ANY TIME AT OUR SOLE DISCRETION. NOTHING IN THESE TERMS AND CONDITIONS SHALL OPERATE TO PREJUDICE
          ANY MANDATORY STATUTORY REQUIREMENT OR YOUR STATUTORY RIGHTS. CONTENT ON THE SERVICES IS PROVIDED FOR YOUR
          GENERAL INFORMATION PURPOSES ONLY AND TO INFORM YOU ABOUT EVENTS OR THIRD PARTY SERVICES WHICH MAY BE OF
          INTEREST. IT DOES NOT CONSTITUTE TECHNICAL, FINANCIAL OR LEGAL ADVICE OR ANY OTHER TYPE OF ADVICE AND SHOULD
          NOT BE RELIED ON FOR ANY PURPOSE. WHILE WE MAKE COMMERCIALLY REASONABLE EFFORTS TO ENSURE THAT THE SERVICES
          ARE AVAILABLE, WE DO NOT REPRESENT, WARRANT OR GUARANTEE IN ANY WAY THE CONTINUED AVAILABILITY OF THE SERVICES
          AT ALL TIMES OR UNINTERRUPTED OR ERROR-FREE USE BY YOU OF THE SERVICES, INCLUDING WITHOUT LIMITATION THE
          ABILITY OF ANY USER TO PERFORM OR ACTUALLY COMPLETE A TRANSACTION.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          10.4 LANGUAGE DISCLAIMER. YOU ACKNOWLEDGE THAT JLIVE HAS NO CONTROL OVER THE LANGUAGE USED BY ORGANIZATIONS IN
          THE DESCRIPTION OF THEIR EVENTS, THEIR PROMOTIONAL MESSAGING CONCERNING SUCH EVENTS, OR THEIR COMMUNICATIONS
          WITH YOU. JLIVE HAS NO RESPONSIBILITY TO YOU TO ENSURE THAT ORGANIZATIONS USING THE SERVICES (A) PROVIDE
          INFORMATION CONCERNING THEIR EVENTS, (B) PROMOTE THOSE EVENTS OR (C) COMMUNICATE WITH YOU IN YOUR PREFERRED
          LANGUAGE OR IN ANY LANGUAGE.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          10.5 Limitation of Liability and Release.
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a){' '}
          <strong>
            LIMITATION OF LIABILITY. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, WE EXCLUDE ALL LIABILITY
            (WHETHER ARISING IN CONTRACT, TORT, BREACH OF STATUTORY DUTY OR OTHERWISE) AS A RESULT OF ANY ERROR OR
            INACCURACIES IN ANY CONTENT, THE UNAVAILABILITY OF THE SERVICES FOR ANY REASON, AND ANY REPRESENTATION OR
            STATEMENT MADE ON THE SERVICES. NEITHER JLIVE, JEWISH FEDERATION OF METROPOLITAN DETROIT OR [FEDERATION CJA]
            NOR ANY OF THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, LICENSORS AND THEIR RESPECTIVE
            SUCCESSORS AND ASSIGNS WILL BE LIABLE FOR ANY DAMAGES OF ANY KIND INCURRED IN CONNECTION WITH YOUR USE,
            MISUSE OR RELIANCE UPON THE SERVICES, YOUR INABILITY TO USE THE SERVICES, THE ACTS OR OMISSIONS OF ANY THIRD
            PARTY SUCH AS OTHER USERS OF THE SERVICES OR ANY OTHER DIRECT, INDIRECT OR CONSEQUENTIAL LOSS OR DAMAGE YOU
            MAY INCUR IN RELATION TO THE SERVICES AND ITS CONTENT. THE FOREGOING LIMITATIONS SHALL APPLY EVEN IF JLIVE
            KNEW OF OR OUGHT TO HAVE KNOWN OF THE POSSIBILITY OF HARM OR DAMAGES.
          </strong>
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b){' '}
          <strong>
            EXCLUSIONS. NOTWITHSTANDING ANY OTHER PROVISION OF THESE TERMS AND CONDITIONS, WE DO NOT EXCLUDE OR LIMIT
            OUR LIABILITY FOR DEATH OR PERSONAL INJURY ARISING FROM OUR NEGLIGENCE, FOR ANY FRAUDULENT MISREPRESENTATION
            MADE BY US ON THE SERVICES OR FOR ANY OTHER STATUTORY RIGHTS WHICH ARE NOT CAPABLE OF BEING EXCLUDED.
          </strong>
        </h3>
      </div>

      <div id="indemnification">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          11. Indemnification.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          11.1 Obligation. You agree to defend, indemnify and hold JLIVE , Jewish Federation of Metropolitan Detroit and
          Federation CJA and each of their respective officers, directors, employees, agents, licensors, payment
          processors, service providers and partners, harmless from and against any and all damage (whether direct,
          indirect, incidental, consequential or otherwise), loss, liability, cost and expense (including, without
          limitation, reasonable attorneys’ and accounting fees) resulting from any claim, demand, suit, proceeding
          (whether before an arbitrator, court, mediator or otherwise) or investigation made by any third party (each a
          “<strong>Claim</strong>”) relating to or arising out of: (a) your breach of these Terms and Conditions
          (including any terms, agreements, policies or guidelines incorporated into these Terms and Conditions); (b)
          your use of the Services in violation of these Terms and Conditions or other policies or guidelines we post or
          make available; (c) your breach of any applicable local, state, provincial, national or other law, rule or
          regulation or the rights of any third party; (d) JLIVE’s collection and remission of taxes; and (e) if you are
          an Organizer, your Events (including where JLIVE has provided Services with respect to those Events),
          including due to or arising out of your or your affiliates’ Permits, any failure to obtain or maintain any
          Permits, or any error in obtaining or maintaining any Permits.{' '}
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          11.2 Procedure. JLIVE will provide notice to you of any such Claim, provided that any failure or delay by
          JLIVE in providing such notice will not limit your obligations hereunder except to the extent you are
          materially prejudiced by such failure. JLIVE reserves the right to choose to handle the Claim itself, in which
          case you agree to cooperate with JLIVE in any way we request. You shall not settle any such Claim without
          JLIVE’s prior written consent.{' '}
        </h2>
      </div>

      <div id="termAndTermination">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          12. Term and Termination.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          12.1 Term. These Terms and Conditions continue in effect until they are terminated in accordance with these
          Terms and Conditions.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          12.2 Termination by JLIVE. JLIVE may terminate your right to use the Services and these Terms and Conditions
          at any time if JLIVE determines, in JLIVE’s sole discretion, that: (a) you violate or breach these Terms and
          Conditions; (b) you misuse or abuse the Services, or use the Services in a way not intended or permitted by
          JLIVE; or (c) allowing you to access and use the Services would violate any applicable local, state,
          provincial, national and other laws, rules and regulations or would expose JLIVE to legal liability.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          12.3 Suspension. JLIVE may choose to stop offering or suspend access to the Services, or any particular
          portion of the Service, or modify or replace any aspect of the Service, at any time. We will use reasonable
          efforts to provide you with notice of our termination or suspension of your access to the Services, where we
          determine, in our sole discretion, that failure to do so would materially prejudice you. You agree that JLIVE
          will not be liable to you or any third party as a result of its termination of your right to use or otherwise
          access the Services.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          12.4 Termination by You. Unless agreed otherwise in a separate written agreement between you and JLIVE, you
          may terminate your access to the Services and the general applicability of these Terms and Conditions by
          deleting your account. If you are a User accessing or using the Services without a registered account, for as
          long as you continue to access or use the Services, even without an account, these Terms and Conditions remain
          in effect. If there is a separate agreement between you and JLIVE governing your use of the Services and that
          agreement terminates or expires, these Terms and Conditions (as unmodified by such agreement) will govern your
          use of the Services after such termination or expiration.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          12.5 Survival. All provisions of these Terms and conditions that by their nature should survive termination of
          these Terms will survive (including, without limitation, all limitations on liability, releases,
          indemnification obligations, disclaimers of warranties, agreements to arbitrate, choices of law and judicial
          forum and intellectual property protections and licenses).
        </h2>
      </div>

      <div id="general">
        <h1
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.title}
        >
          13. General.
        </h1>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.1 Titles and Headings. Section titles in these Terms and Conditions are for convenience and have no legal
          or contractual effect.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.2 Digital Millennium Copy Right Act Notice (DMCA). If you believe any material on, in, or connected to the
          Service or Site constitutes copyright infringement, you shall provide us with the following information:
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) An electronic or physical signature of the person authorized to act on behalf of the owner of the
          copyrighted work.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) An identification of the copyrighted work and location on the website of the alleged infringement.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (c) A written statement that you have a good faith belief that the disputed use is not authorized by the
          owner, its agent or law.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (d) Your name and contact information, including telephone and email address.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (e) A statement by you that the above information in your notice is accurate and, under penalty of perjury,
          that you are the copyright owner or authorized to act on behalf of the copyright owner.
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (f) DMCA notice of claims address is: <strong>6735 Telegraph Rd #30, Bloomfield Hills, MI 48301</strong>
        </h3>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.3 Relationship of the Parties. No independent contractor, agency, partnership, joint venture or other such
          relationship is created by these Terms and Conditions.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.4 Notice. Unless otherwise expressly stated in these Terms and Conditions, all notices from you to us must
          be in writing and sent to our contact address at{' '}
          <strong>5151 Cote Ste. Catherine Road, Montreal, QC, H9G 2T4 - JLIVE@federationcja.org</strong>. All notices
          from us to you will be displayed on our website from to time.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.5 Force Majeure. We shall have no liability to you for any breach of these Terms and Conditions caused by
          any event or circumstance beyond our reasonable control including, without limitation, strikes, lock-outs and
          other industrial disputes, breakdown of systems or network access, flood, fire, explosion or accident.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.6 Severability. If any part of these Terms and Conditions is unenforceable (including any provision in
          which we exclude or limit our liability to you) the enforceability of any other part of these Terms and
          Conditions will not be affected. If we choose not to enforce any right that we have against you at any time,
          then this does not prevent us from later deciding to exercise or enforce that right.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.7 Entire Agreement and Amendment. These Terms and Conditions, together with the Privacy Policy and any
          other terms and conditions expressly referred to in these Terms and Conditions and incorporated by reference,
          contain the entire understanding and agreement between us and you in relation to your use of the Site and
          supersede and replace any representation, statement or other communication (whether written or otherwise) made
          by you or us which is not contained herein. These Terms and Conditions may only be amended by a written
          instrument executed by an authorized representative of each of the parties. Save for fraud or fraudulent
          misrepresentation, we shall have no liability for any such representation being untrue or misleading.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.8 Waiver. Any consent by JLIVE to, or waiver of, a breach of these Terms and Conditions shall not
          constitute a consent to, or waiver of any other, different or subsequent breach.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.9 Assignment. You may not assign, sub-license or otherwise transfer any of your rights and obligations in
          these Terms and Conditions to any other person. We may, without your consent or approval, freely assign these
          Terms and Conditions and our rights and obligations under these Terms and Conditions whether to an affiliate
          or to another entity in connection with a corporate transaction or otherwise.
        </h2>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.10 Governing Law. To the fullest extent allowed under applicable law, all matters relating to your access
          or use of the Services:
        </h2>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (a) United States Users. If you reside in the United States, (i) shall be governed by the laws of the State of
          Michigan and the federal laws applicable therein, without regard to the rules of conflict of law; and (ii) be
          subject to the exclusive jurisdiction of the competent courts of Michigan; and
        </h3>

        <h3
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.list}
        >
          (b) Canadian Users. If you reside in Canada or elsewhere, (i) shall be governed by the laws of the Province of
          Quebec and the federal laws applicable therein, without regard to the rules of conflict of law; and (ii) be
          subject to the exclusive jurisdiction of the competent courts of Quebec.
        </h3>

        <h2
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          className={classes.subtitle}
        >
          13.11 Language. The parties acknowledge that they have required that these Terms and Conditions and all
          related documents be prepared in English. Les parties reconnaissent avoir exigé que la présente convention et
          tous les documents connexes soient rédigés en anglais.
        </h2>
      </div>
    </div>
  );
};

export default TermsOfUseMain;
